/** Utah's words for tasks.ts. */
export const TASKS_UT = {
  /** The espresso-machine descale line: Utah's water is hard, so descale more often. */
  descaleHow: "Per maker; more often with hard Utah water.",
} as const;
